import TermsAndConditionsAccordion from "../__shared__/TermsAndConditionsAccordion/TermsAndConditionsAccordion";
import styles from "./FeatureMessages.module.scss";

type Props = {
  /**
   * Feature messages
   */
  featureMessages: {
    description: string | null | undefined;
    updatedLinksDescription: string;
    terms: string | undefined;
  }[];
};

export const FeatureMessagesUI = ({ featureMessages }: Props) => {
  if (featureMessages.length === 0) {
    return null;
  }

  return (
    <ul
      className={styles.wrapper}
      data-testid="product:feature-messages"
      data-component="FeatureMessages"
    >
      {featureMessages.map((message, idx) => {
        return (
          <li key={idx}>
            <div
              data-testid="product:feature-messages:description"
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: message.description || "",
              }}
            />
            {message.terms && (
              <TermsAndConditionsAccordion terms={message.terms} />
            )}
          </li>
        );
      })}
    </ul>
  );
};
